/* Talho Argentino — avisos de WhatsApp del selector de entrega (19/10/2026).
   1) Ficha de producto: aviso debajo del cuadro de disponibilidad.
   2) Popup "¿Cómo querés recibir tu pedido?" al agregar al carrito (ficha y tarjetas, en cualquier página):
      aviso debajo del botón por si no hay stock para envío o en la tienda que necesitan.
   Lo carga sections/talho-entrega.liquid. Números y texto se editan en el editor de temas (sección "Talho: envío o retiro").
   Backup de la versión anterior (solo ficha): assets/talho-entrega-wa-backup-19oct-b.js */
(function () {
  'use strict';
  var cfg = window.TalhoEntregaWa;
  var C = window.TalhoEntregaCfg;
  if (!cfg || !C || window.__talhoEntregaWa) return;
  window.__talhoEntregaWa = true;

  var TXT = {
    es: { pre: '¿Necesitás sí o sí este producto?', link: 'Escribinos por WhatsApp', post: 'y tratamos de asegurártelo.', msg: 'Hola! Necesito sí o sí este producto: ',
          dlgPre: '¿No está disponible donde lo necesitás?', dlgPost: 'y te ayudamos.' },
    pt: { pre: 'Precisa mesmo deste produto?', link: 'Fale connosco por WhatsApp', post: 'e tentamos garanti-lo.', msg: 'Olá! Preciso mesmo deste produto: ',
          dlgPre: 'Não está disponível onde precisa?', dlgPost: 'e ajudamos.' },
    en: { pre: 'Really need this product?', link: 'Message us on WhatsApp', post: 'and we’ll try to secure it for you.', msg: 'Hi! I really need this product: ',
          dlgPre: 'Not available where you need it?', dlgPost: 'and we’ll help.' },
    fr: { pre: 'Vous avez absolument besoin de ce produit ?', link: 'Écrivez-nous sur WhatsApp', post: 'et nous essaierons de vous le garantir.', msg: 'Bonjour ! J’ai absolument besoin de ce produit : ',
          dlgPre: 'Pas disponible là où vous en avez besoin ?', dlgPost: 'et nous vous aiderons.' }
  };
  var t = TXT[C.lang] || TXT.es;
  if (cfg.texto) t = { pre: cfg.texto, link: t.link, post: '', msg: t.msg, dlgPre: t.dlgPre, dlgPost: t.dlgPost };

  function numero() {
    var n = C.pais === 'PT' ? cfg.pt : cfg.es;
    return String(n || '').replace(/\D/g, '');
  }

  function enlace(nombre, url) {
    var a = document.createElement('a');
    a.href = 'https://wa.me/' + numero() + '?text=' + encodeURIComponent(t.msg + nombre + (url ? ' — ' + url : ''));
    a.target = '_blank';
    a.rel = 'noopener';
    a.textContent = t.link;
    return a;
  }

  /* ---------- 1) Ficha de producto ---------- */
  function tituloFicha() {
    var h = document.querySelector('#MainContent h1');
    return (h && h.textContent.trim()) || document.title;
  }

  function pintar() {
    var caja = document.getElementById('te-ficha');
    var nota = document.getElementById('te-ficha-wa');
    if (!caja || !numero()) { if (nota) nota.hidden = true; return; }
    if (!nota) {
      nota = document.createElement('p');
      nota.id = 'te-ficha-wa';
      nota.className = 'te-ficha-wa';
    }
    if (nota.previousSibling !== caja) caja.parentNode.insertBefore(nota, caja.nextSibling);
    nota.hidden = caja.hidden;
    nota.textContent = '';
    nota.appendChild(document.createTextNode(t.pre + ' '));
    nota.appendChild(enlace(tituloFicha(), location.href.split('?')[0]));
    if (t.post) nota.appendChild(document.createTextNode(' ' + t.post));
  }

  /* ---------- 2) Popup al agregar al carrito ---------- */
  // Producto del último clic de "agregar": tarjeta (.tt-card, que es el propio <a>) o, si no, la ficha.
  var ultimo = null;
  document.addEventListener('click', function (e) {
    var card = e.target && e.target.closest && e.target.closest('.tt-card');
    if (card) {
      var tt = card.querySelector('.tt-t');
      var a = card.matches('a[href]') ? card : card.querySelector('a[href*="/products/"]');
      ultimo = { nombre: tt ? tt.textContent.trim() : '', url: a ? a.href.split('?')[0] : '' };
    } else if (e.target && e.target.closest && e.target.closest('#MainContent form[action*="/cart/add"]')) {
      ultimo = null;
    }
  }, true);

  function notaDialogo(dlg) {
    var form = dlg.querySelector('form');
    if (!form || !numero()) return;
    var nota = form.querySelector('.te-dlg__wa');
    if (!nota) {
      nota = document.createElement('p');
      nota.className = 'te-dlg__wa';
      form.appendChild(nota);
    }
    // Solo cuando el popup se abre al agregar un producto (muestra Disponible / Sin stock).
    var conProducto = !!dlg.querySelector('.te-op__estado');
    nota.hidden = !conProducto;
    if (!conProducto) return;
    var nombre = ultimo && ultimo.nombre ? ultimo.nombre : (C.template === 'product' ? tituloFicha() : '');
    var url = ultimo && ultimo.url ? ultimo.url : (C.template === 'product' ? location.href.split('?')[0] : '');
    nota.textContent = '';
    nota.appendChild(document.createTextNode(t.dlgPre + ' '));
    nota.appendChild(enlace(nombre, url));
    nota.appendChild(document.createTextNode(' ' + t.dlgPost));
  }

  function vigilarDialogo(dlg) {
    if (dlg.__teWa) return;
    dlg.__teWa = true;
    notaDialogo(dlg);
    new MutationObserver(function () { if (dlg.open) notaDialogo(dlg); })
      .observe(dlg, { attributes: true, attributeFilter: ['open'] });
  }

  function buscarDialogo() {
    var d = document.querySelector('dialog.te-dlg');
    if (d) vigilarDialogo(d);
    return !!d;
  }

  var css = document.createElement('style');
  css.textContent = '.te-dlg__wa{margin:-4px 0 0;font-size:.85rem;line-height:1.4;color:#555;text-align:center}' +
    '.te-dlg__wa[hidden]{display:none}' +
    '.te-dlg__wa a{color:#1a1a1a;font-weight:600;text-decoration:underline;text-underline-offset:3px}';
  document.head.appendChild(css);

  var espera;
  function programar() { clearTimeout(espera); espera = setTimeout(pintar, 120); }

  function iniciar() {
    if (!buscarDialogo()) {
      var obs = new MutationObserver(function () { if (buscarDialogo()) obs.disconnect(); });
      obs.observe(document.body, { childList: true });
    }
    if (C.template !== 'product') return;
    pintar();
    new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        var n = muts[i].target;
        if (n && n.id === 'te-ficha-wa') continue;
        if (n && n.closest && n.closest('#te-ficha-wa')) continue;
        programar();
        return;
      }
    }).observe(document.getElementById('MainContent') || document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['hidden'] });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', iniciar);
  else setTimeout(iniciar, 0);
})();
